export const SHIPPING_ADDRESS_FIELDS = {
  ADDRESS: 'shippingAddress',
  ATTENTION: 'shippingAddressAttention',
  CONTACT: 'shippingAddressContact',
};

export const SHIPPING_CUSTOMER_FIELD = 'shippingCustomer';
